import React from 'react';
import LegalPageLayout from '../../components/legal/LegalPageLayout';

export const CookiePolicyPage = () => {
  return (
    <LegalPageLayout title="Çerez Politikası" enTitle="Cookie Policy" updatedAt="11 Ağustos 2026">
      <p className="legal-intro">
        Bu politika, Martinci İmza Yönetim Portalı'nda kullanılan çerez ve benzeri teknolojileri
        açıklar.
      </p>

      <h2>1. Kullandığımız Teknolojiler</h2>
      <p>
        Martinci, reklam veya pazarlama amaçlı üçüncü taraf takip çerezi <strong>kullanmaz</strong>.
        Hizmetin çalışması için gerekli olan yalnızca aşağıdaki iki kategori veri, tarayıcınızın
        yerel depolama alanında (localStorage) tutulur:
      </p>
      <ul>
        <li>
          <strong>Oturum/kimlik doğrulama bilgisi:</strong> giriş yaptığınızda size ait erişim
          belirteci (JWT), oturumunuzu açık tutmak için tarayıcınızda saklanır. Bu, hizmetin temel
          işlevi (giriş yapmış kalmanız) için zorunludur ve kapatılamaz.
        </li>
        <li>
          <strong>Arayüz tercihleri:</strong> örneğin kenar çubuğunun (sidebar) daraltılmış/genişletilmiş
          durumu gibi, sadece görünümünüzü hatırlamamıza yarayan tercihler.
        </li>
      </ul>

      <h2>2. Üçüncü Taraf Çerezleri</h2>
      <p>
        Ödeme adımında yönlendirildiğiniz PAYTR ve bağlantı kurduğunuz Microsoft/Google giriş
        sayfaları kendi çerez politikalarına tabidir; bu sayfalar Martinci'nin kontrolünde değildir.
      </p>

      <h2>3. Bu Verileri Nasıl Yönetebilirsiniz</h2>
      <p>
        Tarayıcınızın ayarlarından localStorage/çerez verilerini istediğiniz zaman temizleyebilirsiniz
        — bu işlem sizi hizmetten çıkış yapmış hâle getirir ve arayüz tercihlerinizi sıfırlar, ancak
        hesabınızı veya verilerinizi etkilemez.
      </p>

      <h2>4. Daha Fazla Bilgi</h2>
      <p>
        Kişisel verilerinizin işlenmesi hakkında daha fazla bilgi için{' '}
        <a href="/gizlilik-politikasi">Gizlilik Politikası</a>'nı ve{' '}
        <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</a>'ni inceleyebilirsiniz.
      </p>
    </LegalPageLayout>
  );
};

export default CookiePolicyPage;
